module.exports = __webpack_public_path__ + "static/media/4.16133d3a.JPG";